import { useState } from 'react';
import classes from './CopyReference.module.scss';

const CopyReference = (props) => {
    const [textState, setTextState] = useState('copy');
    const preText = props.ticketId;

    const copy = async () => {
        await navigator.clipboard.writeText(preText);
        setTextState('');
    };

    return (
        <div className={classes.oReferenceNumber}>
            <div className={classes.mReferenceNumber}>
                <span className={`${classes.aText} fnt24f`}>{preText}</span>
                <figure
                    className={`${classes.mRefIcon} ${textState ? '' : classes.isCopied}`}
                    onClick={copy}
                >
                    <svg
                        width="17"
                        height="18"
                        viewBox="0 0 17 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2.23757 5.0625C2.23757 3.09825 3.82699 1.5 5.78039 1.5H12.5923C12.3469 0.63675 11.5645 0 10.6285 0H2.05111C0.919641 0 0 0.92475 0 2.0625V13.6875C0 14.8253 0.919641 15.75 2.05111 15.75H2.23757V5.0625Z"
                            fill="#1565C0"
                        />
                        <path
                            d="M14.3579 3H5.7806C4.64913 3 3.72949 3.92475 3.72949 5.0625V15.9375C3.72949 17.0753 4.64913 18 5.7806 18H14.3579C15.4894 18 16.409 17.0753 16.409 15.9375V5.0625C16.409 3.92475 15.4894 3 14.3579 3ZM12.8662 15.75H7.27231C6.96353 15.75 6.71292 15.498 6.71292 15.1875C6.71292 14.877 6.96353 14.625 7.27231 14.625H12.8662C13.175 14.625 13.4256 14.877 13.4256 15.1875C13.4256 15.498 13.175 15.75 12.8662 15.75ZM12.8662 12.75H7.27231C6.96353 12.75 6.71292 12.498 6.71292 12.1875C6.71292 11.877 6.96353 11.625 7.27231 11.625H12.8662C13.175 11.625 13.4256 11.877 13.4256 12.1875C13.4256 12.498 13.175 12.75 12.8662 12.75ZM12.8662 10.125H7.27231C6.96353 10.125 6.71292 9.87301 6.71292 9.56251C6.71292 9.25201 6.96353 9 7.27231 9H12.8662C13.175 9 13.4256 9.25201 13.4256 9.56251C13.4256 9.87301 13.175 10.125 12.8662 10.125ZM12.8662 7.125H7.27231C6.96353 7.125 6.71292 6.873 6.71292 6.5625C6.71292 6.252 6.96353 6 7.27231 6H12.8662C13.175 6 13.4256 6.252 13.4256 6.5625C13.4256 6.873 13.175 7.125 12.8662 7.125Z"
                            fill="#1565C0"
                        />
                    </svg>
                </figure>
            </div>
            <div className={`${classes.oSnackbar} ${textState ? '' : classes.isCopied}`}>
                <div className={classes.mSnackbar}>
                    <figure className={classes.mIcon}>
                        <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M21.5 6L9.125 18L3.5 12.5455"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </figure>
                    <span className={classes.aText}>Copied to clipboard</span>
                </div>
            </div>
        </div>
    );
};

export default CopyReference;
